// src/services/authService.ts
import axios from "axios";

const API_URL = "https://portfoliom-backend.vercel.app/auth";

const getToken = () => localStorage.getItem("token");

export const editUser = async (id: number, data: { username?: string; role?: string }) => {
  try {
    const token = getToken();
    const res = await axios.put(`${API_URL}/users/${id}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return res.data; // { success: boolean, user: User }
  } catch (err: any) {
    console.error(err);
    throw new Error(err.response?.data?.message || "Kullanıcı güncellenemedi");
  }
};